//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminTransactionController_toExcel,
  Response$AdminTransactionController_toExcel$Status$200,
  ResponseContentType$AdminTransactionController_toExcel,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminTransactionController_toExcel = (options: {
  params: Params$AdminTransactionController_toExcel['parameter'];
  config?: QueryOptions<
    Response$AdminTransactionController_toExcel$Status$200[ResponseContentType$AdminTransactionController_toExcel]
  >;
}) =>
  useApiClient<
    Params$AdminTransactionController_toExcel,
    Response$AdminTransactionController_toExcel$Status$200[ResponseContentType$AdminTransactionController_toExcel]
  >({
    method: 'AdminTransactionController_toExcel',
    params: { parameter: options.params },
    config: options.config,
    requestOptions: { responseType: 'blob' },
  });
